import React from 'react';
import TasksList from './TasksList';

interface ContactTasksListProps {
  publicClientId: number;
  publicCompanyId: number;
}

export default function ContactTasksList(props: ContactTasksListProps) {
  return (
    <TasksList
      mode="contact"
      publicClientId={props.publicClientId}
      publicCompanyId={props.publicCompanyId}
      hideFilters={false}
      hideSettings={true}
    />
  );
}